import { render, staticRenderFns } from "./MessageStatusIndicator.vue?vue&type=template&id=c1525732"
import script from "./MessageStatusIndicator.vue?vue&type=script&lang=js"
export * from "./MessageStatusIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports